"use client";

import { useTranslations } from "next-intl";
import Image from "next/image";
import { FaLinkedin, FaTwitter } from "react-icons/fa";

export default function JourneySection() {
	const t = useTranslations("Journey");
	const tCommon = useTranslations("Common");

	return (
		<section className="relative min-h-[95rem] bg-[#ccf5ff] mt-16 rounded-br-[20%_12%] min-[901px]:rounded-br-[20%_12%]">
			<div
				className="absolute top-0 left-0 w-full h-[31rem] bg-no-repeat bg-cover"
				style={{ backgroundImage: "url(/assets/vendors/wave-top4.png)" }}
			/>
			<div className="relative w-full section-padding pt-[25rem] pb-20">
				<h3 className="text-[2.8rem] font-normal text-center text-black py-6 px-6 m-0">
					{t("title")}
				</h3>
				<p className="text-[1.8rem] text-black text-center">{t("subtitle")}</p>
				<div className="flex flex-wrap justify-evenly gap-8 mt-4">
					<div className="px-6 py-4 flex-[0_1_85rem] my-8 mx-2 text-center bg-white">
						<div className="relative w-[15.2rem] h-[15.2rem] rounded-full overflow-hidden mx-auto mb-4">
							<Image
								src="/assets/profile/dragos_leonte152px.webp"
								alt={t("dragosName")}
								fill
								sizes="152px"
								className="object-cover"
							/>
						</div>
						<span className="text-[2rem] text-[#6c6d6d] uppercase block my-2">
							{t("coFounderCeo")}
						</span>
						<h4 className="text-[2.8rem] font-normal my-4 text-black">
							{t("dragosName")}
						</h4>
						<p className="text-[1.6rem] text-[#717488] py-2 px-2">
							{t("dragosBio")}
						</p>
						<div className="flex justify-center gap-2 text-[2.4rem] text-[#6c6d6d] [&>a:hover]:text-[#0d6efd]">
							<a
								href="https://www.linkedin.com/in/dragos-leonte-77890b69/"
								target="_blank"
								rel="noreferrer nofollow"
								aria-label={tCommon("linkedin")}
							>
								<FaLinkedin />
							</a>
							<a
								href="https://twitter.com/DragosLeonte1"
								target="_blank"
								rel="noreferrer nofollow"
								aria-label={tCommon("twitter")}
							>
								<FaTwitter />
							</a>
						</div>
					</div>
					<div className="px-6 py-4 flex-[0_1_85rem] my-8 mx-2 text-center bg-white">
						<div className="relative w-[15.2rem] h-[15.2rem] rounded-full overflow-hidden mx-auto mb-4">
							<Image
								src="/assets/profile/paul_poterasi152px.webp"
								alt={t("paulName")}
								fill
								sizes="152px"
								className="object-cover"
							/>
						</div>
						<span className="text-[2rem] text-[#6c6d6d] uppercase block my-2">
							{t("coFounderCeo")}
						</span>
						<h4 className="text-[2.8rem] font-normal my-4 text-black">
							{t("paulName")}
						</h4>
						<p className="text-[1.6rem] text-[#717488] py-2 px-2">
							{t("paulBio")}
						</p>
						<div className="flex justify-center gap-2 text-[2.4rem] text-[#6c6d6d] [&>a:hover]:text-[#0d6efd]">
							<a
								href="https://www.linkedin.com/in/poterasipaul/"
								target="_blank"
								rel="noreferrer nofollow"
								aria-label={tCommon("linkedin")}
							>
								<FaLinkedin />
							</a>
							<a
								href="https://twitter.com/p_paul88/"
								target="_blank"
								rel="noreferrer nofollow"
								aria-label={tCommon("twitter")}
							>
								<FaTwitter />
							</a>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
